// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "input,textarea{margin-top:.5rem;margin-bottom:.5rem;border-radius:.5rem;border-width:1px;padding:1rem;font-size:.875rem;line-height:1.25rem;font-family:Contantia;border-color:#8c8c8c;letter-spacing:2px;background:transparent;--tw-bg-opacity:0.5}input:hover,textarea:hover{--tw-bg-opacity:1;background-color:rgb(255 255 255 / var(--tw-bg-opacity))}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
